import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform, InputAccessoryView } from "react-native";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
import { connect } from "react-redux";
import { searchItems } from "../../actions/records";
import { getMyCustomers, getMySuppliers } from "../../actions/submissions";
import DropDownLocations from "../widgets/dropdownLocations";
import colors from "../../constants/colors";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import Swal from "sweetalert2";
import BarcodeScannerComponent from "../widgets/BarCodeScannerComponent";
import KeyboardBar from "../widgets/KeyboardBar";
import { inputFocus } from "../../utils";

class SearchInventoryLocations extends Component {
    inputRef = createRef();

    constructor(props) {
        super(props);
        this._interval = null;
        const useScanner = props.isShipmentByLocation && props.showLocationsSearch && props.defaultLabel === "location";
        this.state = {
            value: (props.defaultLabel == "toLocation" || props.showLocationsSearch) ? this.renderLocation(props.initial) : typeof props.initial == "string" ? props.initial : "",
            locationSelected: props.initial && typeof props.initial == "object" ? props.initial : [],
            height: 30,
            items: props.options ? props.options : [],
            filtered: props.options ? props.options : [],
            wasEdited: false,
            openList: false,
            scan: false,
            scanerCanceled: false,
            softFocus: useScanner && props.scannerInput ? false : true,
            inputAccessoryViewID: useScanner ? `location-${props.id}-${props.position}` : undefined,
        };
    }
    componentDidMount() {
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.openBarCodeScanner != this.props.openBarCodeScanner && nextProps.openBarCodeScanner) {
            this.showScanner(true);
        }
        if (nextProps?.options != this.props.options) {
            this.setState({ items: nextProps.options, filtered: nextProps.options, });
        }
        if (nextProps?.initial != this.props.initial && typeof nextProps?.initial == "object") {
            //this.setState({ locationSelected: nextProps?.initial, value: this.renderLocation(nextProps?.initial) });
            if (this.props.defaultLabel == "toLocation" || this.props.showLocationsSearch) {
                this.setState({ value: this.renderLocation(nextProps.initial) });
            } else {
                this.setState({ locationSelected: nextProps?.initial });
            }
        }
        if (nextProps?.initial != this.props.initial && typeof nextProps?.initial == "string") {
            this.setState({ value: nextProps?.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch) {
            this.setState({ filtered: [], wasEdited: false });
        }
    }
    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval);
    }

    useScannerField() {
        const { isShipmentByLocation, showLocationsSearch, defaultLabel } = this.props;
        return !!(isShipmentByLocation && showLocationsSearch && defaultLabel === "location");
    }

    scannerFieldActive() {
        const { showScanner, scannerInput } = this.props;
        return showScanner || (this.useScannerField() && scannerInput);
    }

    showScanner(value) {
        this.setState({ scan: value, scanerCanceled: value ? false : this.state.scanerCanceled });
    }

    showScannerInput() {
        const { setFormScroll } = this.props;
        if (!this.state.scanerCanceled) {
            if (setFormScroll) setFormScroll(false);
            setTimeout(() => {
                this.showScanner(true);
                setTimeout(() => {
                    if (setFormScroll) setFormScroll(true);
                }, 300);
            }, 500);
        } else {
            this.setState({ scanerCanceled: false });
        }
    }

    normalizeScannedLocation(data) {
        var scanned = (data || "").trim();
        var scannedArray = scanned.split("-");
        if (scannedArray.length <= 1) {
            scannedArray = scanned.split("/");
        }
        if (scannedArray.length > 0) {
            scanned = "";
            scannedArray.forEach((part) => {
                scanned += part.trim().replace(/ /g, "");
            });
        }
        return scanned.toLowerCase();
    }

    getLocationMatchKey(location) {
        var completeLocation = "";
        if (location?.site?.locationName) completeLocation += location.site.locationName.trim();
        if (location?.zone?.locationName) completeLocation += location.zone.locationName.trim();
        if (location?.aisle?.locationName) completeLocation += location.aisle.locationName.trim();
        if (location?.rackBay?.locationName) completeLocation += location.rackBay.locationName.trim();
        if (location?.shelfLevel?.locationName) completeLocation += location.shelfLevel.locationName.trim();
        if (location?.bin?.locationName) completeLocation += location.bin.locationName.trim();
        return completeLocation.trim().replace(/ /g, "").replace(/[/-]+/g, "").toLowerCase();
    }

    findLocationByScan(data) {
        const { items } = this.state;
        const scanned = this.normalizeScannedLocation(data);
        if (!scanned || !items?.length) return null;
        var match = null;
        items.forEach((location) => {
            if (match) return;
            if (scanned === this.getLocationMatchKey(location)) {
                match = location;
            }
        });
        return match;
    }

    handleBarCodeScanned(data) {
        const { handleFocusOnElement } = this.props;
        this.setState({ scan: false }, () => {
            setTimeout(() => {
                if (handleFocusOnElement && this.inputRef?.current) {
                    handleFocusOnElement(this.inputRef.current);
                }
            }, 100);
            if (!data) return;
            var location = this.findLocationByScan(data);
            if (location) {
                this.selectLocation(location);
            } else {
                Swal.fire({
                    text: "Sorry, the scanned location does not exist on inventory",
                    confirmButtonText: "Accept",
                    confirmButtonColor: colors.orange,
                    backdrop: false,
                });
            }
        });
    }
    searchItems(val, focused) {
        const { items } = this.state;
        const { isShipmentByLocation } = this.props;
        var search = val;
        if (this._interval) clearInterval(this._interval);
        if (search) {
            search = search.toLowerCase().trim();
            //Take first 10 items
            var filtered = items.filter((item) => {
                var completeLocation = "";
                if (item?.site?.locationName) {
                    completeLocation += item.site.locationName;
                }
                if (item?.zone?.locationName) {
                    completeLocation += "-" + item.zone.locationName;
                }
                if (item?.aisle?.locationName) {
                    completeLocation += "-" + item.aisle.locationName;
                }
                if (item?.rackBay?.locationName) {
                    completeLocation += "-" + item.rackBay.locationName;
                }
                if (item?.shelfLevel?.locationName) {
                    completeLocation += "-" + item.shelfLevel.locationName;
                }
                if (item?.bin?.locationName) {
                    completeLocation += "-" + item.bin.locationName;
                }
                completeLocation = completeLocation.toLowerCase().trim();
                return completeLocation.includes(search);
            });
            if(isShipmentByLocation)filtered = filtered.slice(0, 10);
            this.setState({ filtered: filtered, openList: true });

        } else {
            var filtered = [];
            if(isShipmentByLocation)filtered = items.slice(0, 10); else filtered = items;
            this.setState({ filtered, wasEdited: focused ? true : false, openList: true });
        }
    }
    noFoundLocation(search) {
        const { onSelectItem } = this.props;
        search = search.toLowerCase().trim();
        var filtered = this.state.items.filter((item) => {
            var completeLocation = "";
            if (item?.site?.locationName) {
                completeLocation += item.site.locationName;
            }
            if (item?.zone?.locationName) {
                completeLocation += "-" + item.zone.locationName;
            }
            if (item?.aisle?.locationName) {
                completeLocation += "-" + item.aisle.locationName;
            }
            if (item?.rackBay?.locationName) {
                completeLocation += "-" + item.rackBay.locationName;
            }
            if (item?.shelfLevel?.locationName) {
                completeLocation += "-" + item.shelfLevel.locationName;
            }
            if (item?.bin?.locationName) {
                completeLocation += "-" + item.bin.locationName;
            }
            completeLocation = completeLocation.toLowerCase().trim();
            return completeLocation.includes(search);
        });
        if (filtered.length <= 0)
            Swal.fire({
                text: "This location does not exist. A new main location will be created automatically on sending the form, but it must be reorganized by an administrator. This is not recommended. Do you want to proceed?",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                showCancelButton: true,
                confirmButtonColor: colors.orange,
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setState({ value: search, filtered: [], openList: false });
                    onSelectItem(search);
                } else {
                    this.setState({ value: "", filtered: [], openList: false });
                    onSelectItem("");
                }
            });
    }
    selectLocation(item) {
        const { onSelectItem } = this.props;
        onSelectItem([item]);
        this.setState({
            value: this.renderLocation(item),
            wasEdited: false,
            openList: false,
            filtered: [],
        });
    }

    renderLocation(location) {
        var item = location;
        if (typeof item == "object" && item?.length > 0) {
            item = item[0];
        } else if (typeof item == "string") {
            return item;
        }
        var completeLocation = "";
        if (item?.site?.locationName) {
            completeLocation += item.site.locationName;
        }
        if (item?.zone?.locationName) {
            completeLocation += "-" + item.zone.locationName;
        }
        if (item?.aisle?.locationName) {
            completeLocation += "-" + item.aisle.locationName;
        }
        if (item?.rackBay?.locationName) {
            completeLocation += "-" + item.rackBay.locationName;
        }
        if (item?.shelfLevel?.locationName) {
            completeLocation += "-" + item.shelfLevel.locationName;
        }
        if (item?.bin?.locationName) {
            completeLocation += "-" + item.bin.locationName;
        }
        return completeLocation;
    }
    render() {
        const { value, items, wasEdited, filtered, openList, scan, scanerCanceled, softFocus, inputAccessoryViewID } = this.state;
        const { defaultComponent, onSelectItem, placeholder, customers, width, isRecipe, openDropDown, backgroundColor, isLast, defaultLabel, isDropDownOpened, resetDropDown, onFocus, setShowTextBar, showLocationsSearch, isShipmentByLocation, handleFocusOnElement, setFormScroll, id, position, scannerInput, showScanner } = this.props;
        const useScanner = this.useScannerField();
        const scannerFieldForInput = this.scannerFieldActive();

        if (scan && useScanner) {
            return (
                <View style={{ ...styles.container, paddingTop: width ? 0 : 5 }}>
                    <BarcodeScannerComponent
                        onBarCodeScanned={(e) => this.handleBarCodeScanned(e)}
                        closeScanner={() => {
                            this.showScanner(false);
                            if (scannerInput && scannerFieldForInput) {
                                this.setState({ scanerCanceled: true }, () => {
                                    setTimeout(() => inputFocus(this.inputRef), 500);
                                });
                            }
                        }}
                        style={styles.absoluteFillObject}
                    />
                </View>
            );
        }

        return <View>
            <TextInput
                {...getNoAutofillProps()}
                ref={noAutofillRef(this.inputRef)}
                value={value}
                editable={!defaultComponent && !(useScanner && scannerInput && scannerFieldForInput && !value && !scanerCanceled && Platform.OS === "ios")}
                showSoftInputOnFocus={Platform.OS === "ios" ? true : softFocus}
                onPress={() => {
                    if (Platform.OS === "ios" && useScanner && scannerInput && scannerFieldForInput && !value && !scanerCanceled) {
                        this.showScannerInput();
                    }
                    if (Platform.OS === "web" && isMobileWeb() && !defaultComponent && onFocus) {
                        onFocus();
                    }
                }}
                onFocus={() => {
                    if (useScanner && Platform.OS !== "ios" && scannerInput && scannerFieldForInput && !value && !scanerCanceled) {
                        this.showScannerInput();
                        if (!softFocus) {
                            this.setState({ softFocus: true });
                            return;
                        }
                    }
                    const skipParentScannerReopen = useScanner && scannerInput && scannerFieldForInput && !value && scanerCanceled;
                    if (onFocus && !skipParentScannerReopen) {
                        onFocus();
                    } else if (skipParentScannerReopen) {
                        setTimeout(() => {
                            if (handleFocusOnElement && this.inputRef?.current) {
                                handleFocusOnElement(this.inputRef.current);
                            }
                        }, 300);
                    }
                    if (!defaultComponent && !value) this.searchItems("", true);
                    if (useScanner && setShowTextBar && isMobileWeb()) {
                        setShowTextBar(id, position, [], null, null, null, null, false, true);
                    } else if (setShowTextBar && (isMobileWeb() || Platform.OS === "android")) {
                        setShowTextBar(null, null, null, null, null, null, null, false);
                    }
                }}
                onContentSizeChange={(event) => {
                    if (event.nativeEvent.contentSize.height == 0) {
                        if (this.props.placeholder == '') {
                            this.setState({ height: 30 })
                        }
                        this.setState({ height: event.nativeEvent.contentSize.height });
                    } else {
                        setTimeout(() => {
                            this.setState({ height: event.nativeEvent.contentSize.height });
                        }, 5)
                    }
                }}
                onBlur={() => {
                    if (useScanner && scannerInput && scannerFieldForInput) {
                        this.setState({ scanerCanceled: false });
                        if (softFocus) this.setState({ softFocus: false });
                    }
                    if (useScanner && setShowTextBar && isMobileWeb()) {
                        setShowTextBar(null, null, null, null, null, null, null, false);
                    }
                    if ((defaultLabel == "toLocation" || showLocationsSearch) && value && filtered?.length <= 0) {
                        this.noFoundLocation(value);
                    }
                }}
                inputAccessoryViewID={useScanner ? inputAccessoryViewID : undefined}
                style={{
                    ...styles.input,
                    borderColor: "#e7e7e7",
                    borderRadius: 5,
                    borderWidth: 1,
                    color: "#424242",
                    fontFamily: "Roboto",
                    fontSize: 20,
                    fontWeight: "400",
                    padding: 5,
                    height: this.state.height,
                    fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                    overflow: 'hidden'
                }}
                multiline={true}
                placeholder={placeholder}
                placeholderTextColor={'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                    if (val == '' && this.props.placeholder == '') {
                        this.setState({ value: val, height: 30, wasEdited: true });

                    } else {
                        this.setState({ value: val, wasEdited: true });
                    }
                    if (this._interval) clearInterval(this._interval);
                    this._interval = setInterval(() => this.searchItems(val, false), 500);
                    onSelectItem(val);
                }}
            />
            {Platform.OS === "ios" && useScanner && (
                <InputAccessoryView nativeID={inputAccessoryViewID}>
                    <KeyboardBar
                        abcOptionPress={null}
                        scanOptionPress={() => this.showScanner(true)}
                    />
                </InputAccessoryView>
            )}
            {
                items?.length > 0 && defaultLabel != "toLocation" && !showLocationsSearch &&
                <DropDownLocations
                    initialOption={this.state.locationSelected}
                    updated={this.state.locationSelected}
                    options={filtered}
                    defaultComponent={defaultComponent}
                    openList={openList}
                    allLabel={"All Locations"}
                    onSelect={(option) => {
                        onSelectItem(option)
                    }}
                    width={width}
                    isRecipe={isRecipe}
                    openDropDown={openDropDown}
                    backgroundColor={backgroundColor}
                    isLast={isLast}
                    isDropDownOpened={isDropDownOpened}
                    resetDropDown={resetDropDown}
                    showScanner={showScanner}
                />
            }
            {
                filtered?.length > 0 && (defaultLabel == "toLocation" || showLocationsSearch) && wasEdited &&
                <View style={styles.listContainer}>
                    {filtered.map((item, idx) => (
                        <TouchableOpacity
                            key={idx}
                            style={styles.row}
                            onPress={() => this.selectLocation(item)}
                        >
                            <View style={styles.rowText}>
                                <Text style={styles.rowLabel}>{this.renderLocation(item)}</Text>
                            </View>
                            <TouchableOpacity
                                style={styles.rowBtn}
                                onPress={() => this.selectLocation(item)}
                            >
                                <MaterialCommunityIcons name="plus" size={22} color={colors.selectSearch} />
                            </TouchableOpacity>
                        </TouchableOpacity>
                    ))}
                </View>
            }
            {
                (value && filtered?.length <= 0 && wasEdited) ? <View>
                    <Text>No locations were found</Text>
                </View> : null
            }
        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
    company_id: state.user.get("company_id"),
}), (dispatch, props) => ({
    searchItems: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchItems(formid, saveAsTemplate, saveAsForm, callback)),
    getMyCustomers: (data, callback) =>
        dispatch(getMyCustomers(data, callback)),
    getMySuppliers: (id, page, filter, callback) =>
        dispatch(getMySuppliers(id, page, filter, callback)),
}))(SearchInventoryLocations);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    listContainer: {
        paddingTop: 4,
        width: "100%",
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        paddingVertical: 6,
        paddingHorizontal: 4,
        borderBottomWidth: 1,
        borderBottomColor: "#e7e7e7",
    },
    rowText: {
        flex: 1,
        paddingRight: 8,
    },
    rowLabel: {
        fontFamily: "Roboto",
        fontSize: 18,
        color: "#424242",
    },
    rowBtn: {
        borderRadius: 4,
        padding: 6,
        borderWidth: 1,
        borderColor: colors.selectSearch,
        alignItems: "center",
        justifyContent: "center",
        minWidth: 36,
        minHeight: 36,
    },
    absoluteFillObject: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
});